import { Divider } from '@mui/material';
export const PartDivider = () => <Divider sx={{
  borderColor: 'common.backgroundColor',
  borderBottomWidth: 2,
  my: 3.5,
  display: ['none', 'none', 'block']
}} data-sentry-element="Divider" data-sentry-component="PartDivider" data-sentry-source-file="PartDivider.tsx" />;